export const EnFooter = {
  "footer": {
    "contact": "CONTACT",
    "data": "DISCLAIMER",
    "faq": "F.A.Q",
    "impress": "IMPRINT",
    "legal": "LEGAL NOTICE",
    "poweredBy": "powered by"
  },
}